import { createAction } from 'redux-actions'

const ns = 'superAdmin/'

export const searchCompanies = createAction(`${ns}SEARCH_COMPANIES`)
export const searchCompaniesSuccess = createAction(`${ns}SEARCH_COMPANIES_SUCCESS`)
export const searchCompaniesFail = createAction(`${ns}SEARCH_COMPANIES_FAIL`)

export const setSuperAdminTargetCompany = createAction(`${ns}SET_TARGET_COMPANY`)
export const updateSuperAdminTargetCompanyInfo = createAction(`${ns}UPDATE_TARGET_COMPANY_INFO`)
export const clearSuperAdminTargetCompany = createAction(`${ns}CLEAR_TARGET_COMPANY`)
